import React from 'react';
import {
    HeaderMi,
    HeaderLogo,
    HeaderServiceMi,
    Logo,
    HeaderToolsRaccourcis,
    HeaderToolsRaccourcisItem,
    HeaderNavList,
    HeaderNavItem,
    SkipLinks,
    SkipLinkItem,
    HeaderOperateur,
    Link,
} from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './header.module.scss';
import { FEATURE_TITRES_DETENTION, isFeatureActive } from '../FeatureFlipping/featureFlipping.func';
import { DROITS_HEADER_TITRE_DETENTION } from '../../utils/droitsEtRoles.constant';
import verifierDroits from '../VerifierDroits/verifierDroits.func';

const HeaderComponent = ({ isConnecte, dataProfil, dataNotification, featureFlipping }) => {
    const TITRE_HEADER = "Système d'Information sur les Armes";
    const SOUS_TITRE_HEADER = 'Espace Détenteurs';
    const RATELIER_LABEL = 'Mon râtelier';
    const TITRE_DETENTION_LABEL = 'Mes titres de détention';
    const DEMARCHE_LABEL = 'Mes démarches';
    const RGA_LABEL = 'RGA';
    const TYPE_LIEN = 'lien';
    const TYPE_LIEN_EXTERNE = 'lienExterne';
    const { REACT_APP_RGA_URL } = process.env;
    const marqueEtatPersonnalisee = {
        titreLigneUne: 'Ministère',
        titreLigneDeux: "de l'intérieur",
    };
    const prenomFormat = (prenom) => {
        return prenom.charAt(0) + prenom.substring(1).toLowerCase();
    };

    let liensRaccourcis = [];
    let liensNavbarGauche = [];
    let liensNavbarDroite = [];

    if (isConnecte && dataProfil) {
        liensRaccourcis = [
            {
                utilisateur: `${prenomFormat(dataProfil.prenom)} ${dataProfil.nom}\nN°SIA: ${
                    dataProfil.numeroSia
                }`,
            },
            {
                url: '/espace-detenteurs/aide',
                nom: 'Aide',
                icone: 'fr-fi-information-line',
            },
            {
                url: '/deconnexion',
                nom: 'Déconnexion',
                icone: 'fr-fi-lock-line',
            },
        ];
    } else {
        liensRaccourcis = [
            {
                url: '/compte/creer/aide',
                nom: 'Aide',
                icone: 'fr-fi-information-line',
            },
        ];
    }
    if (isConnecte && dataProfil && featureFlipping) {
        liensNavbarGauche = [
            {
                nom: RATELIER_LABEL,
                url: '/espace-detenteurs/ratelier',
                type: TYPE_LIEN,
            },
            {
                nom: TITRE_DETENTION_LABEL,
                url: '/espace-detenteurs/mes-titres-de-detention',
                type: TYPE_LIEN,
            },
            {
                nom: DEMARCHE_LABEL,
                url: '/espace-detenteurs/mes-demarches',
                type: TYPE_LIEN,
            },
        ];

        if (REACT_APP_RGA_URL) {
            liensNavbarGauche.push({
                nom: RGA_LABEL,
                url: REACT_APP_RGA_URL,
                type: TYPE_LIEN_EXTERNE,
            });
        }

        // retirer le menu TITRE_DETENTION lorsque la feature est désactivé
        if (!isFeatureActive(featureFlipping, FEATURE_TITRES_DETENTION)) {
            liensNavbarGauche = liensNavbarGauche.filter(
                (element) => !element.nom.includes(TITRE_DETENTION_LABEL),
            );
        } else if (
            !isFeatureActive(featureFlipping, FEATURE_TITRES_DETENTION) ||
            !verifierDroits(dataProfil, DROITS_HEADER_TITRE_DETENTION)
        ) {
            liensNavbarGauche = liensNavbarGauche.filter(
                (element) => !element.nom.includes(TITRE_DETENTION_LABEL),
            );
        }

        liensNavbarDroite = [
            {
                nom: `Notifications: ${
                    dataNotification ? dataNotification.nombreNotificationsUsager : '0'
                }`,
                url: '/espace-detenteurs/notifications',
                type: TYPE_LIEN,
            },
            {
                nom: 'Mon profil',
                url: '/espace-detenteurs/mon-compte/gestion',
                type: TYPE_LIEN,
            },
        ];
    }

    return (
        <div className={styles['Header-Margin']}>
            <SkipLinks>
                <SkipLinkItem href="#contenu">Contenu</SkipLinkItem>
                <SkipLinkItem href="#navigation-header">Menu</SkipLinkItem>
                <SkipLinkItem href="#footer">Pied de page</SkipLinkItem>
            </SkipLinks>
            <HeaderMi>
                <HeaderLogo>
                    <Logo>
                        {marqueEtatPersonnalisee.titreLigneUne} <br />
                        {marqueEtatPersonnalisee.titreLigneDeux} <br />
                        {marqueEtatPersonnalisee.titreLigneTrois}
                        {marqueEtatPersonnalisee.titreLigneQuatre}
                    </Logo>
                </HeaderLogo>
                <HeaderOperateur>
                    <Link
                        href="/"
                        title={`Accueil - ${TITRE_HEADER} - ${SOUS_TITRE_HEADER}`}
                        passHref
                    >
                        <HeaderServiceMi baseline={SOUS_TITRE_HEADER} titre={TITRE_HEADER} />
                    </Link>
                </HeaderOperateur>
                <HeaderToolsRaccourcis>
                    {liensRaccourcis.map((lien) => {
                        if (lien.utilisateur) {
                            return (
                                <li>
                                    <span
                                        className={styles['Nom-Prenom-Sia']}
                                        key={lien.utilisateur}
                                    >
                                        {lien.utilisateur}
                                    </span>
                                </li>
                            );
                        }
                        return (
                            <HeaderToolsRaccourcisItem
                                href={lien.url}
                                className={lien.icone}
                                key={lien.nom}
                            >
                                {lien.nom}
                            </HeaderToolsRaccourcisItem>
                        );
                    })}
                </HeaderToolsRaccourcis>
                <HeaderNavList>
                    {liensNavbarGauche.concat(liensNavbarDroite).map((nav) => {
                        return (
                            <HeaderNavItem
                                href={nav.url}
                                key={nav.nom}
                                as={
                                    [TYPE_LIEN, TYPE_LIEN_EXTERNE].includes(nav.type) ? 'a' : 'span'
                                }
                                target={nav.type === TYPE_LIEN_EXTERNE ? '_blank' : '_self'}
                            >
                                {nav.nom}
                            </HeaderNavItem>
                        );
                    })}
                </HeaderNavList>
            </HeaderMi>
        </div>
    );
};

HeaderComponent.propTypes = {
    isConnecte: PropTypes.bool,
    dataProfil: PropTypes.shape({
        prenom: PropTypes.string.isRequired,
        nom: PropTypes.string.isRequired,
        numeroSia: PropTypes.string.isRequired,
        roles: PropTypes.array.isRequired,
    }),
    dataNotification: PropTypes.shape({
        nombreNotificationsUsager: PropTypes.number.isRequired,
    }),
    featureFlipping: PropTypes.object,
};

HeaderComponent.defaultProps = {
    isConnecte: false,
    dataProfil: null,
    dataNotification: null,
};

export default connect((state) => {
    const { data } = state.profil.usager;
    const { data: dataNotification } = state.notification.nombreNotificationsUsager;
    const { data: featureFlipping } = state.featureFlipping;
    return {
        dataProfil: data,
        dataNotification,
        featureFlipping,
    };
})(HeaderComponent);
